export default __webpack_public_path__ + "static/media/neat.139a9174.svg";